RivalIQ.apps.SocialPosts.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const PostTagsList = RivalIQ.postTags.views.PostTagManager.mixin({

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        className: 'post-tags-list',

        initialize: function () {
            const me = this;

            const curation = me.dashboardModel.getCuration();
            const postsTable = curation.getWidget(me.dashboardModel.postsTableInstanceId);

            me.options.postsTable = postsTable;
            RivalIQ.postTags.views.PostTagManager.prototype.initialize.apply(me);

            me._onScrollHandler = _.debounce(function () {
                me._updateHeightHack();
            }, 0, {
                leading: true,
                trailing: true,
                maxWait: 10
            });

            $(document).on('scroll', me._onScrollHandler);

            postsTable.on('change', function () {
                const orderBy = postsTable.getProp('orderBy');
                const sortOrder = postsTable.getProp('sortOrder');
                Marionette.Dashboard.utils.object.set(curation.queryProps, {
                    orderBy,
                    sortOrder
                });

                const path = curation.getPath(curation.queryProps);
                Backbone.history.navigate(path, {
                    replace: true
                });
            });
        },

        onAttachLoaded: function () {
            const me = this;

            me.requestRenderedFrame(function () {
                $('body').addClass('body-post-tags-manager');
                me.updateListScrollBarVisibility();
            });
        },

        onDestroy: function () {
            const me = this;
            $(document).off('scroll', me._onScrollHandler);
            $('body').removeClass('body-post-tags-manager');
        },

        _updateHeightHack: function () {
            const me = this;

            const postTagsList = me.$el.get(0);

            if (postTagsList) {
                const boundingRect = postTagsList.getBoundingClientRect();

                const extraMargin = 0;
                const top = boundingRect.top;

                const newMaxHeight = Math.min(window.innerHeight - top - extraMargin, window.innerHeight - extraMargin);
                me.$el.css('height', `${newMaxHeight}px`);
                me.$el.css('max-height', `${newMaxHeight}px`);
            }
        },

        // We need to override updateListScrollBarVisibility since it will be called while we're still loading the widget
        // (i.e., before our dom elements are rendered).
        updateListScrollBarVisibility: function () {
            const me = this;

            me._updateHeightHack();

            const listSection = $('.post-tags-list-section').get(0);
            if (listSection) {
                const listAvailableHeight = listSection.clientHeight - $('.post-tags-apply-controls').get(0).clientHeight;
                const $listEl = me.$el.find('.post-tags-list-container');
                const needsScrollbars = $listEl.get(0).scrollHeight > listAvailableHeight;

                $listEl.toggleClass('show-scrollbars', needsScrollbars);
            }

            const hasAutoTag = Boolean(me.collection.find('post_auto_tag_id'));
            if (hasAutoTag) {
                me.ui.manageCurrentRules.show();
            } else {
                me.ui.manageCurrentRules.hide();
            }
        }
    });

    const PostTagsListWidget = RivalIQ.apps.Dashboard.models.Widget.extend({
        view: PostTagsList,
        hasFooter: _.constant(false),
        panelView: RivalIQ.apps.Dashboard.views.Panel.extend({
            onRender: function () {
                const me = this;
                if (!me._isShown) {
                    me.actions.reset();
                    me.showContent();
                }
            }
        })
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.POST_TAGS_LIST, PostTagsListWidget);
});
